// Public Radar URLs: /radar/{section}/{slug}. Falls back to the id for
// legacy records (the detail page then canonicalises to the slug URL).
const SECTION = {
  news: "news",
  job: "jobs", jobs: "jobs",
  alert: "alerts", alerts: "alerts",
  insight: "insights", insights: "insights",
  tutorial: "tutorials", tutorials: "tutorials",
};

export const articlePath = (type, item) => `/radar/${SECTION[type] || type}/${item?.slug || item?.id}`;
